import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import FileDownloadTwoToneIcon from "@mui/icons-material/FileDownloadTwoTone";
import { TextFieldDisabled } from "./TextFieldDisabled";
import { useMemo } from "react";
import { MaterialReactTable } from "material-react-table";
import { config, functions, validateFunction } from "./config";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

function SeguimientoItem({
  id,
  mes,
  coordenadas,
  ejecutado,
  descripcion,
  evidencias,
  reportado,
  eliminarSeguimiento,
}) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const columnsUnidades = useMemo(() => [
    {
      accessorKey: "categoria",
      header: "Categoria",
      size: 40,
    },
    {
      accessorKey: "unidad",
      header: "Unidad",
      size: 40,
    },
    {
      accessorKey: "cantidad",
      header: "Cantidad",
      size: 40,
    },
  ]);
  const columnsEvidencias = useMemo(() => [
    {
      accessorKey: "descripcion",
      header: "Descripción",
    },
    {
      accessorKey: "nombre",
      size: 1,
      Cell: ({ renderedCellValue, row }) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Link href={config.evidencias_url + row.original.nombre} target="_blank">
            <IconButton size="small">
              <FileDownloadTwoToneIcon /> Ver {row.original.tipo}
            </IconButton>
          </Link>
        </Box>
      ),
    },
  ]);

  return (
    <Container
      maxWidth="lg"
      sx={{ border: { xs: "0", sm: "1px solid #000" }, mt: 2 }}
    >
      <Grid container spacing={3} rowSpacing={1}>
        <Grid item xs={12} sm={6}>
          <TextFieldDisabled title="Mes de Ingreso" value={mes} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextFieldDisabled title="Coordenadas" value={coordenadas} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextFieldDisabled title="Descripción" value={descripcion} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextFieldDisabled title="Ejecutado en el mes" value={ejecutado} />
        </Grid>
        <Grid item xs={12} sm={6}>
          {evidencias && (
            <Grid item xs={12}>
              <Box
                sx={{
                  padding: "16.5px 14px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography variant="overline">Evidencias</Typography>

                <MaterialReactTable
                  columns={columnsEvidencias}
                  data={evidencias}
                  enableColumnActions={false}
                  enableColumnFilters={false}
                  enablePagination={false}
                  enableSorting={false}
                  enableBottomToolbar={false}
                  enableTopToolbar={false}
                  muiTableBodyRowProps={{ hover: false }}
                  muiTableProps={{
                    sx: {
                      border: "1px solid rgba(81, 81, 81, 1)",
                    },
                  }}
                  muiTableHeadCellProps={{
                    sx: {
                      border: "1px solid rgba(81, 81, 81, 1)",
                    },
                  }}
                  muiTableBodyCellProps={{
                    sx: {
                      border: "1px solid rgba(81, 81, 81, 1)",
                    },
                  }}
                />
              </Box>
            </Grid>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box sx={{ padding: "16.5px 14px" }}>
            <Typography variant="overline">Cantidad Reportada</Typography>
            <MaterialReactTable
              columns={columnsUnidades}
              data={reportado}
              enableColumnActions={false}
              enableColumnFilters={false}
              enablePagination={false}
              enableSorting={false}
              enableBottomToolbar={false}
              enableTopToolbar={false}
              muiTableBodyRowProps={{ hover: false }}
              muiTableProps={{
                sx: {
                  border: "1px solid rgba(81, 81, 81, 1)",
                },
              }}
              muiTableHeadCellProps={{
                sx: {
                  border: "1px solid rgba(81, 81, 81, 1)",
                },
              }}
              muiTableBodyCellProps={{
                sx: {
                  border: "1px solid rgba(81, 81, 81, 1)",
                },
              }}
            />
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          sx={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          {validateFunction(user, functions.ModifySeguimiento) && (
            <Button
              type="submit"
              onClick={() => {
                navigate("/SeguimientoEditar", {
                  state: { id: id },
                });
              }}
              variant="contained"
              className="warningBg"
              sx={{ mb: 2 }}
              padding={1}
            >
              Editar
            </Button>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          sx={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          {validateFunction(user, functions.DeleteSeguimiento) && (
            <Button
              onClick={eliminarSeguimiento}
              variant="contained"
              color="error"
              sx={{ mb: 2 }}
              padding={1}
            >
              Eliminar
            </Button>
          )}
        </Grid>
      </Grid>
    </Container>
  );
}

export { SeguimientoItem };
